/**
 * DUP-3 (W6): makes `organisationId` the active organisation of the super
 * admin, then opens `/team`. Switching reloads the page (ENG-9): flags and
 * caches follow the new organisation. Already active: plain navigation.
 * Used by the organisation row (AdminOrganisations) and by the redirect of
 * the former `/organisations/:id/members` (TeamShell).
 */
export async function openOrganisationTeam(
  organisationId: string,
  deps: { activeOrganisationId: string | undefined; switchOrganisation: (id: string) => Promise<unknown>; navigate: (to: string) => void },
): Promise<void> {
  if (deps.activeOrganisationId === organisationId) {
    deps.navigate('/team');
    return;
  }
  await deps.switchOrganisation(organisationId);
  window.location.assign('/team');
}
